import { CustomCellRendererWithSkeleton } from "../../components";
import {
  getReceiptPrintDate,
  getHistoryOutletName,
  getInventoryHistoryType,
  getActionColumnOfAgGridReact,
  parseToThousandSeperatorDecimalNumber,
  parseToThousandSeperatorWholeNumber,
} from "../../utility";

const getInventoryHistoryTableColumns = () => {
  return [
    {
      headerName: "Date",
      field: "createdOn",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          titleToolTipText={getReceiptPrintDate(params.data.createdOn)}
          componentRenderCondition={params?.data?.product_name}
          cellComponent={getReceiptPrintDate(params.data.createdOn)}
        />
      ),
    },
    {
      headerName: "Activity",
      field: "TransactionType",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          titleToolTipText={getInventoryHistoryType(params.data)}
          componentRenderCondition={params?.data?.TransactionType}
          cellComponent={getInventoryHistoryType(params.data)}
        />
      ),
    },
    {
      headerName: "Name",
      field: "product.name",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          titleToolTipText={params?.data?.product?.name}
          componentRenderCondition={params?.data?.product?.name}
          cellComponent={params?.data?.product?.name}
        />
      ),
    },
    {
      headerName: "Type",
      field: "product.productType",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={params?.data?.product?.productType}
          cellComponent={params?.data?.product?.productType}
        />
      ),
    },
    {
      headerName: "Category",
      field: "product.category",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={params?.data?.product?.category}
          cellComponent={params?.data?.product?.category}
        />
      ),
    },
    {
      headerTooltip: "Unit Purchase Price",
      headerName: "Unit Purchase Price",
      field: "cogs",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={!isNaN(params?.data?.cogs)}
          cellComponent={`$${parseToThousandSeperatorDecimalNumber(
            params.data.cogs
          )}`}
        />
      ),
    },
    {
      headerTooltip: "Unit Sell Price",
      headerName: "Unit Sell Price",
      field: "amount",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={!isNaN(params?.data?.amount)}
          cellComponent={`$${parseToThousandSeperatorDecimalNumber(
            params.data.amount
          )}`}
        />
      ),
    },
    {
      headerName: "Quantity",
      field: "quantity",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={!isNaN(params?.data?.quantity)}
          cellComponent={`${parseToThousandSeperatorWholeNumber(
            params.data.quantity
          )}`}
        />
      ),
    },
    {
      headerName: "Outlet",
      field: "outlet",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={params?.data?.createdOn}
          cellComponent={getHistoryOutletName(params.data.outlet?.name)}
        />
      ),
    },
    getActionColumnOfAgGridReact(
      (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={params?.data?.processedBy}
          cellComponent={params?.data?.processedBy}
        />
      ),
      "Processed By"
    ),
  ];
};

export { getInventoryHistoryTableColumns };
